"use strict";

import asyncAppend from "@elements/async-append";
import initModulesInScope from "@elements/init-modules-in-scope";

export function initInScope($scope) {

    $scope.find('.js-load-store-info__select').on('change', function (e) {
        let $select = $(this),
            url = $select.find(':selected').data('url');

        let $target = $select.closest('.js-load-store-info__result');
        let $loading = $target.find('.js-load-store-info__loading');
        let notification = $target.find('.js-load-store-info__notification');

        asyncAppend({
            $target: $target,
            $loading: $loading,
            notifications: notification
        }, fetch(url)).then((result) => {
        }).catch((e) => {
            console.log('catch', e)
        });

    });

}